import Link from "../../../../components/link/Link";
import { NoData, RenderWhen } from "../../../../components";
import LinkVariant from "../../../../components/link/@types/LinkVariant";
import { getSearchPivotLink } from "../../../samples/util";
import { SEARCH_FIELDS } from "../../mappings";
import {
  applyQueryTransformations,
  formatQueryValue,
  removeIllegalCharacters
} from "../utils";

type Props = {
  className?: string;
  value: string | number;
  keyword: keyof typeof SEARCH_FIELDS;
  children?: React.ReactNode;
  variant?: LinkVariant;
  "data-testid"?: string;
};

const SearchLink = ({
  className,
  value = "",
  keyword,
  variant = "basic",
  children,
  "data-testid": dataTestId
}: Props) => {
  const transformedValue = applyQueryTransformations(value, [
    removeIllegalCharacters,
    encodeURIComponent,
    formatQueryValue
  ]);
  const to = getSearchPivotLink(`${SEARCH_FIELDS[keyword]}${transformedValue}`);
  return (
    <RenderWhen condition={!!value} fallback={<NoData />}>
      <Link
        to={to}
        className={className}
        variant={variant}
        data-testid={dataTestId}
      >
        {children || value}
      </Link>
    </RenderWhen>
  );
};

export default SearchLink;
